<template>
   <div>

      <!-- IMAGE UPLOADER -->
      <el-form
         :model="image"
         class="dashboard-form"
         size="small"
         enctype="multipart/form-data"
         method="post"
         @submit.stop.prevent
      >

         <b-row class="text-center text-xl-left">
            <b-col cols="12" class="text-center">

               <el-upload
                  action=""
                  class="avatar-uploader mb-3"
                  :class="{square}"
                  ref="file"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="setAvatarPhoto"
                  :style="{width, height, margin: 'auto'}"
                  title="Clique para Altera a Foto do Perfil"
               >
                  <!-- View photo -->

                     <el-image
                        @click="fixRelativeBody"
                        v-if="this.user.avatar.filename"
                        :src="createUrlAvatar(this.user.avatar)"
                        fit="cover"
                        class="avatar"
                        style="width: 90%; height: 90%"
                     ></el-image>
                     <i v-else-if="loading.image"  class="spinner-grow text-primary text-center"></i>
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>


               </el-upload>

               <el-button
                  v-if="user.avatar"
                  @click="removeImage"
                  class="btnDelAvatar"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  title="Remover"></el-button>

               <el-button
                  v-if="loading.image"
                  @click="postImage"
                  type="primary"
                  size="mini"
                  title="Enviar"
                  :loading="loading.image"
                  :disabled="loading.image"
               >{{ loading.image ? "Enviando..." : 'Enviar' }}
               </el-button>
            </b-col>

         </b-row>
      </el-form>

   </div>
</template>

<script>
import imageCompression from "browser-image-compression";
import header from "@/services/header";
import UserService from "@/services/user.service";
import user from '@/models/User';

export default {
   name: 'ImageUpload',
   props: {
      imageUri: String,
      width: {
         type: String,
         default: '130px'
      },
      height: {
         type: String,
         default: '130px'
      },
      square: {
         type: Boolean,
         default: false
      }
   },

   data() {
      return {
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         image: null,
         imageSaveBtn: false,
         loading: {
            image: false,
            saveImage: false
         },
         user,
      }
   },

   async mounted() {
      await this.getUser();
      this.user = this.userData.data
   },



   methods: {

      //Obtem os dados do usuário.
      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },

      //Methods for handling photos | Métodos para lidar com as fotos
      setAvatarPhoto(file) {

         this.loading.image = true
         this.imageUri = ''

         setTimeout(() => {
            if (this.photoIsOK(file)) {

               let imageFile = file.raw;

               let options = {
                  maxSizeMB: 0.3,
                  maxWidthOrHeight: 620,
                  useWebWorker: true,
                  maxIteration: 50,
                  onProgress: () => false
               };

               imageCompression(imageFile, options)
                  .then((compressedFile) => {
                     this.imageUri = URL.createObjectURL(compressedFile);
                     this.image = compressedFile;
                     this.postImage()
                     this.loading.image = false
                     this.imageSaveBtn = true
                  })
                  .catch(function (error) {
                     this.loading.image = false
                     this.$message.error(`Ops, algo deu errado. Erro: ${error}`);
                  });
            }

         }, 100)

      },

      postImage() {
         let formData = new FormData();
         formData.append('avatar', this.image);
         formData.append('_id', this.user._id);

         const imageUri = `${this.baseUrl + this.apiV1}/user/update/avatar`;

         this.loading.saveImage = true;

         this.axios.post(imageUri, formData, header)
            .then(async (response) => {
               this.$message({
                  message: response.data.message,
                  type: 'success'
               });
               await this.getUser();
               this.user = this.userData.data
               this.loading.saveImage = false;
               this.imageSaveBtn = false;
               await this.getUser()
            })
            .catch((e => {
               this.$message.error(e.response.data.message);
               this.loading.image = false;
            }));
      },

      fixRelativeBody() {
         let body = document.querySelector("body");
         body.style.overflow = 'visible';
      },

      removeImage() {
         const imageUri = `${this.baseUrl + this.apiV1}/user/update/avatar`;

         this.$confirm('Você tem certeza que quer deletar seu avatar?', 'Deletar foto do perfil', {
            confirmButtonText: 'Sim, quero deletar',
            cancelButtonText: 'Cancelar',
            type: 'warning'
         }).then(() => {
            this.axios.delete(imageUri, header)
               .then(async (response) => {
                  this.$message({
                     message: response.data.message,
                     type: 'success'
                  });
                  this.user.avatar.filename = ''
                  await this.getUser();

               })
               .catch((e => {
                  this.$message.error(e.response.data.message);
               }));
         })

      },

      photoIsOK(file) {

         const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

         if (!allowedTypes.includes(file.raw.type)) {
            this.$message.error('ATENÇÃO: Somente imagens no formato JPEG, JPG e PNG.');
            this.loading.image = false;
            return false;
         }

         const maxSize = file.raw.size > 10000000;

         if (maxSize) {
            this.$message.error('A foto não deve ser maior que 10mb.');
            this.loading.image = false;
            return false
         }

         return true;
      },

      createUrlAvatar(url) {
         let uri;
         const imgDir = url.destination;
         if (url.filename) {
            uri = `${this.baseUrl}/${imgDir}/${url.filename}`
            return uri;
         }
      }

   },

   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      userData() {
         return this.$store.state.user
      }
   },

   watch: {


   }

}
</script>

<style lang="scss">
.avatar-uploader {
   .el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
   }

   &.square {
      .el-upload {
         border-radius: 5px;
      }
   }
}

</style>
